
import { defineComponent, onMounted, ref } from "vue";
import GlobalHeader from "@/components/GlobalHeader.vue";
import Park from "@/components/Park.vue";
import "swiper/swiper-bundle.min.css";

export default defineComponent({
  components: {
    GlobalHeader,
    Park,
  },
  setup() {
    const isHeader = ref<boolean>(false);
    const header = (value: boolean) => {
      isHeader.value = value;
    };

    const isGlobalMenuOpen = ref<boolean>(false);
    const globalMenu = (value: boolean) => {
      isGlobalMenuOpen.value = value;
    };

    const isShow = ref<boolean>(false);
    const isStart = ref<boolean>(false);
    const start = () => {
      isStart.value = true;
    };

    const show = (value: boolean) => {
      isShow.value = value;
      const body = document.querySelector<HTMLElement>("body");
      if (body) body.style.overflowY = value ? "hidden" : "auto";
    };

    const isMount = ref<boolean>(false);
    onMounted(() => {
      isMount.value = true;
    });

    return {
      header,
      isHeader,
      isShow,
      isStart,
      isGlobalMenuOpen,
      globalMenu,
      start,
      show,
    };
  },
});
